// Copyright © Veeam Software Group GmbH

import React, { useMemo } from 'react';
import { map } from 'rxjs/operators';
import first from 'lodash/first';
import { BodyLayout, SplitLayout, TitleH2, StackView, STACK_DIRECTION, INDENT } from '@veeam/components';

import type { FC } from 'react';

import { EventsGrid } from './components/EventsGrid';
import { SessionsGrid } from './components/SessionsGrid';
import { useRestoreSessionRouting } from '../../infrastructure/routing';
import { useSessionsModel } from './components/SessionsGrid/hooks/useModel';

export const RestoreSessionsPage: FC = () => {
    const { sessionId } = useRestoreSessionRouting().getQuery();
    const restoreSessionsModel = useSessionsModel(sessionId);
    const session = useMemo(
        () => restoreSessionsModel.asObservable().pipe(map(value => first(value.selection))),
        [],
    );

    return (
        <BodyLayout>
            <SplitLayout
                direction={STACK_DIRECTION.column}
                start={(
                    <StackView spaceBottom={INDENT.s} size={{ height: '100%', width: '100%' }} direction={STACK_DIRECTION.column}>
                        <SessionsGrid model={restoreSessionsModel} />
                    </StackView>
                )}
                startConfig={{
                    size: 0.7,
                    minSize: 0.3,
                }}
                end={(
                    <StackView spaceTop={INDENT.m} size={{ height: '100%', width: '100%' }} direction={STACK_DIRECTION.column}>
                        <TitleH2>{'Session Log: '}</TitleH2>
                        <EventsGrid session={session} />
                    </StackView>
                )}
                endConfig={{
                    minSize: 0.3,
                }}
            />
        </BodyLayout>
    );
};
